import { FunctionComponent } from "react";

import { Modal, ModalCloseButton, ModalOverlay, ModalContent, Box, Icon } from "@chakra-ui/react";
import { IconShieldCheck } from "@tabler/icons-react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}
export const ReLoginModal: FunctionComponent<Props> = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent bg={"gray.50"}>
                <ModalCloseButton />
                <Box textAlign={"center"} gap={"1rem"} mb={"2rem"} p={"1rem"}>
                    <Icon ml={"1rem"} as={IconShieldCheck} color={"blue.400"} boxSize={"5rem"} />
                    <Box ml={"1rem"} fontSize={"large"} fontWeight={"bold"}>
                        We've got your back!
                    </Box>
                    <Box padding={"1rem"}>
                        We noticed your previous session was inactive for an extended period or it wasn't properly closed. For your security, we logged you out
                        of the application.
                        <br /> <br />
                        To continue, please login again.
                    </Box>
                </Box>
            </ModalContent>
        </Modal>
    );
};
